export default __webpack_public_path__ + "static/media/Ancient Arbalest.6419b27c.jpg";